'use client';

import { type LucideIcon } from 'lucide-react';
import { useNavigate } from 'react-router';

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';

export function NavMain({
  items,
}: {
  items: {
    title: string;
    url: string;
    icon?: LucideIcon;
    isActive?: boolean;
    hasPendingProposals?: boolean;
    items?: {
      title: string;
      url: string;
    }[];
  }[];
}) {
  const navigate = useNavigate();
  return (
    <SidebarGroup>
      <SidebarMenu>
        {items.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton
              asChild
              tooltip={item.title}
              isActive={item.isActive ?? false}
            >
              <button
                type="button"
                onClick={() => navigate(item.url)}
                aria-label={
                  item.hasPendingProposals
                    ? `${item.title} — pending proposals`
                    : undefined
                }
                className="hover:color-sidebar-accent-foreground hover:border-none border-none font-normal text-sidebar-primary-foreground text-left w-full"
              >
                {item.icon && (
                  <span className="relative flex size-4 shrink-0">
                    <item.icon className="size-4" />
                    {item.hasPendingProposals && (
                      <span
                        aria-hidden="true"
                        className="absolute -right-1 -top-1 size-2 rounded-full bg-red-500 ring-2 ring-sidebar"
                      />
                    )}
                  </span>
                )}
                <span>{item.title}</span>
              </button>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
